<template lang="html">
  <div id="chart-trending-comments"></div>
</template>

<script>
  import { mapGetters } from 'vuex';
  // import c3 from 'c3';
  import find from 'lodash/find';

  export default {
    data() {
      return {};
    },
    props: {
      onlineTrendingData: {
        type: Array,
        default() {
          return [];
        },
      },
    },
    methods: {},
    computed: {
      ...mapGetters(['getCurrentRT']),
    },
    mounted() {
      const chartArgument = (variablesToShow) => ({
        bindto: '#chart-trending-comments',
        data: {
          json: variablesToShow,
          keys: {
            x: 'rtname',
            // value: ['comments', 'stars', 'points'],
            value: ['comments', 'points'],
            submitted: 'submitted',
          },
          colors: {
            // stars: '#73ccd7',
            comments: '#ec2e7c',
            points: '#293349',
          },
          names: {
            // stars: 'Stars Received',
            comments: 'Comments Made',
            points: 'Points Received From Teacher',
          },
          labels: false,
          type: 'bar', // set defaut type
          // types: { // set specific type
          //   comments: 'line', // can also be 'sline' or 'area'
          // },
        },
        legend: {
          position: 'right',
        },
        axis: {
          x: {
            type: 'category',
          },
        },
        // point: {
        //   r: 4, // size of the circle for 'line', 'sline' and 'area' chart types
        // },
        zoom: {
          enabled: true,
        },
        transition: {
          duration: 1000,
        },
        tooltip: {
          contents: function tooltip(
            d,
            defaultTitleFormat,
            defaultValueFormat,
            color
          ) {
            const config = this.config;
            const titleFormat =
              config.tooltip_format_title || defaultTitleFormat;
            const nameFormat =
              config.tooltip_format_name ||
              function getName(name) {
                return name;
              };
            const valueFormat =
              config.tooltip_format_value || defaultValueFormat;
            const submissionFormat = (name) => {
              if (name) {
                return 'Yes';
              }
              return 'No';
            };
            let text;
            let i;
            let title;
            let value;
            let name;
            let bgcolor;
            let submitted;

            for (i = 0; i < d.length; i += 1) {
              if (!text) {
                title = titleFormat ? titleFormat(d[i].x) : d[i].x;
                // find the obj containing the rtname and adds a new key to show
                // if the student submitted a response or not
                d.submitted = find(variablesToShow, {
                  rtname: title,
                }).submitted;
                submitted = submissionFormat(d.submitted);
                text = `<table class='${this.CLASS.tooltip}'>
                        <tr><th colspan='2'>${title}</th></tr>
                        <tr><td class='name'>Responded?</td>
                          <td class='value'>${submitted}</td>
                        </tr>`;
              }

              name = nameFormat(d[i].name);
              value = valueFormat(d[i].value, d[i].ratio, d[i].id, d[i].index);
              bgcolor = this.levelColor
                ? this.levelColor(d[i].value)
                : color(d[i].id);

              text += `<tr><td class='name'>
                      <span style='background-color:${bgcolor}'></span>${name}</td>
                      <td class='value'>${value}</td>
                     </tr>`;
            }
            return `${text}</table>`;
          },
        },
      });
      this.$watch('onlineTrendingData', (summaryArray) => {
        const argument = chartArgument(summaryArray);
        import(/* webpackChunkName: "c3" */ 'c3').then((c3) => {
          c3.generate(argument);
        });
        return;
      });
    },
  };
</script>

<style lang="css">
  /* import css from node_modules/c3 */
  @import '~c3/c3.min.css';

  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  #chart-trending-comments {
    animation: fadein 1.5s;
  }

  /* can change style using #chart(div id) + c3 class + data id */
  #chart-trending-comments .c3-line-comments {
    stroke-width: 1px;
  }
</style>



// WEBPACK FOOTER //
// trendingComments.vue?01375af4